import React, { Component } from 'react';
import loadScripts  from '../../../dassets/js/custom';
import { Link } from 'react-router-dom';

class Stockbroking extends Component {
  componentDidMount(){
    loadScripts();
  }
  render() {
    return (
      <>
      {/* =================================
    Inner Header */}
    <div className="inner-header bg-light">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
            <h1 className="breadcrumb-title mb-0">Stockbroking</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
              <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
              <li className="breadcrumb-item"><span>Services</span></li>
              <li className="breadcrumb-item active"><span>Stockbroking</span></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  {/* =================================
  Inner Header */}
  
  
  <section className="space-ptb">
    <div className="container">
      <div className="row">
        <div className="col-md-4 col-xl-3">
          <ul className="list-unstyled vertical-menu border border-2 rounded p-3">
                  <li><Link to={"/services/issuing-house"}><span>Issuing House</span></Link></li>
                  <li><Link className="active" to={"/services/stockbroking"}><span>Stockbroking</span></Link></li>
                  <li><Link to={"/services/financial-advisory"}><span>Financial Advisory</span></Link></li>
                  <li><Link to={"/services/portfolio-management"}><span>Portfolio Management</span></Link></li>
                  <li><Link to={"/services/fund-management"}><span>Fund Management</span></Link></li>
                  <li><Link to={"/services/lagos-commodities-and-future-exchange"}><span>Lagos Commodities and Future Exchange</span></Link></li>
          </ul>
          <div className="bg-dark rounded p-4 mb-md-0 mb-5">
            <span className="lead text-primary fw-bold">Do you have a question? Please contact us</span>
            <h6 className="text-white mt-3">+(234) 0805 555 0606</h6>
            <span className="text-white">info@dynamicportfolio.com</span>
          </div>
        </div>
        <div className="col-md-8 col-xl-9">
          {/* <img className="img-fluid mb-4" src={require("./../../dassets/images/service/10.jpg")} alt=""/> */}
          <div className="mb-md-5 mb-4">
            <h4 className="mb-4">Stockbroking</h4>
            <div className='mb-4'>
                  <h6>Purchase and sale of securities </h6>
                  <p>We deal in the purchase and sale of securities on behalf of our numerous clients. We deal in all securities quoted on The Nigerian Exchange Group (NGX) and National Association of Securities Dealers (NASD) on behalf of our clients. These securities include Equities, Industrial Loan stock, Preference Shares and Government bonds etc.</p>
                  </div>
            <div className='mb-4'>
                  <h6>Other related activities include:</h6>
                  <ul className="list">
                <li><i className="far fa-circle"></i> Nominal transfer on behalf of related parties, individuals or corporate entities </li>
                <li><i className="far fa-circle"></i> Stockbrokers to listed companies on retainership basis </li>
                <li><i className="far fa-circle"></i> Nominee and Custodianship Services</li>
                <li><i className="far fa-circle"></i> Verification of signatures by clients either for deposit at the Central Securities Clearing System (CSCS) or for the purpose of pledging such securities as collateral</li>
                <li><i className="far fa-circle"></i> Investment Advisory Services on capital market investment and portfolio management. The Investment Advisory Services package covers essentially; professional advise on available investment opportunities, timely purchase and/or sale of investments and review of existing portfolio for corporate and high net-worth individual investors to maximize return on their investments.</li>
              </ul>
                  </div>
            <div className='mb-4'>
                  <h6>Broker to New Issues</h6>
                  <p>Dynamic Portfolio Limited acts as stockbrokers to companies accessing the capital market via Offer for Subscription, Offer for Sales, Rights Issues and Listing by introduction.</p>
                  <p>Our activities in this respect include among others;</p>
                  <ul className="list">
                <li><i className="far fa-circle"></i> Prepare and present formal application to The Nigerian Exchange Group for the admission of the Issue to the Daily Official List. </li>
                <li><i className="far fa-circle"></i> Ensuring that the application is heard in compliance with the set Time-table for the Issue.</li>
                <li><i className="far fa-circle"></i> Effective participation in the marketing of the Issue. </li>
                <li><i className="far fa-circle"></i> Offer necessary advice to the Issuer to ensure compliance with the Listing requirements and other guidelines of The Nigerian Exchange Group in relation to the Issue.</li>
                <li><i className="far fa-circle"></i> Listing of the Issue on The Nigerian Exchange Group.</li>
                <li><i className="far fa-circle"></i> Provision of post-offer advice to the Issuer.</li>
              </ul>
                  </div>
          </div>
        </div>
      </div>
    </div>
  </section>
      </>
    );
  }
}

export default Stockbroking;